import {gql} from "@apollo/client";
import {client} from "graphql/client";

export const GET_ACCOUNT_WAREHOUSE_MANAGER_BY_ACCOUNT_ID = gql`
    query GetAccountWarehouseManagerByAccountId($accountId: Long!) {
        getAccountWarehouseManagerByAccountId(accountId: $accountId) {
            id
            accountId
            warehouseId
        }
    }
`;

export interface AccountWarehouseManagerType {
    id: number;
    accountId: number;
    warehouseId: number;
}

export interface GetAccountWarehouseManagerByAccountIdQueryVariables {
    accountId: number;
}

export interface GetAccountWarehouseManagerByAccountIdQuery {
    getAccountWarehouseManagerByAccountId: AccountWarehouseManagerType;
}

export const getAccountWarehouseManagerByAccountId = async (accountId: number): Promise<AccountWarehouseManagerType> => {
    const {data} = await client.query<GetAccountWarehouseManagerByAccountIdQuery, GetAccountWarehouseManagerByAccountIdQueryVariables>({
        query: GET_ACCOUNT_WAREHOUSE_MANAGER_BY_ACCOUNT_ID,
        variables: {accountId}
    });
    return data.getAccountWarehouseManagerByAccountId;
};